import React, { useState, useEffect, useCallback } from 'react';

import expense from "../../images/mobile/4.jpg";
import expense1 from "../../images/mobile/4-1.jpg";
import expense2 from "../../images/mobile/4-2.jpg";
import contacts from "../../images/mobile/1.jpg";
import contacts1 from "../../images/mobile/1-1.jpg";
import clients from "../../images/mobile/3.jpg";
import attendance from "../../images/mobile/2.jpg";
import attendance1 from "../../images/mobile/2-1.jpg";
import attendance2 from "../../images/mobile/2-2.jpg";

const WorkAppsheet = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [currentProduct, setCurrentProduct] = useState(null);
  const [activeTab, setActiveTab] = useState(0);

  // 모달 열린 상태에서 스크롤 방지
  useEffect(() => {
    if (selectedImage) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [selectedImage]);

  const products = [
    {
      title: '비용 처리 시스템',
      description: '간편한 경비 청구와 승인 프로세스',
      features: [
        '실시간 경비 청구 및 승인',
        '영수증 이미지 첨부 기능',
        '자동 인식(상점,비용,일자)',        
      ],
      images: [expense, expense1, expense2],
      color: 'blue'
    },
    {
      title: '사내 연락처 관리',
      description: '임직원 정보의 통합 관리 솔루션',
      features: [
        '구성원 관리',
        '임직원 검색 기능',        
      ],
      images: [contacts, contacts1],
      color: 'indigo'
    },
    {
      title: '거래처 관리 시스템',
      description: '거래처 정보 및 이력 통합 관리',
      features: [
        '거래처 정보 데이터베이스',
        '거래처 이력 추적',
      ],
      images: [clients],
      color: 'purple'
    },
    {
      title: '출/퇴근 기록 시스템',
      description: '효율적인 근태 관리 솔루션',
      features: [
        'GPS 기반 출/퇴근 기록',
      ],
      images: [attendance, attendance1, attendance2],
      color: 'teal'
    }
  ];

  const handleImageClick = (image, product, index) => {
    setSelectedImage(image);
    setCurrentImageIndex(index);
    setCurrentProduct(product);
  };

  const handlePrevImage = (e) => {
    e.stopPropagation();
    if (currentImageIndex > 0) {
      setSelectedImage(currentProduct.images[currentImageIndex - 1]);
      setCurrentImageIndex(currentImageIndex - 1);
    }
  };

  const handleNextImage = (e) => {
    e.stopPropagation();
    if (currentImageIndex < currentProduct.images.length - 1) {
      setSelectedImage(currentProduct.images[currentImageIndex + 1]);
      setCurrentImageIndex(currentImageIndex + 1);
    }
  };

  const handleKeyDown = useCallback((e) => {
    if (!selectedImage) return;
    
    if (e.key === 'ArrowLeft') {
      if (currentImageIndex > 0) {
        setSelectedImage(currentProduct.images[currentImageIndex - 1]);
        setCurrentImageIndex(currentImageIndex - 1);
      }
    } else if (e.key === 'ArrowRight') {
      if (currentImageIndex < currentProduct.images.length - 1) {
        setSelectedImage(currentProduct.images[currentImageIndex + 1]);
        setCurrentImageIndex(currentImageIndex + 1);
      }
    } else if (e.key === 'Escape') {
      setSelectedImage(null);
      setCurrentImageIndex(0);
      setCurrentProduct(null);
    }
  }, [currentImageIndex, currentProduct, selectedImage]);

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown]);

  // 색상 매핑 헬퍼 함수 추가
  const getActiveTabColor = (color) => {
    switch(color) {
      case 'blue': return 'bg-blue-600';
      case 'indigo': return 'bg-indigo-600';
      case 'purple': return 'bg-purple-600';
      case 'teal': return 'bg-teal-600';
      default: return 'bg-blue-600';
    }
  };

  const getCardHeaderGradient = (color) => {
    switch(color) {
      case 'blue': return 'bg-gradient-to-r from-blue-500 to-blue-700';
      case 'indigo': return 'bg-gradient-to-r from-indigo-500 to-indigo-700';
      case 'purple': return 'bg-gradient-to-r from-purple-500 to-purple-700';
      case 'teal': return 'bg-gradient-to-r from-teal-500 to-teal-700';
      default: return 'bg-gradient-to-r from-blue-500 to-blue-700';
    }
  };

  const getCardRingColor = (color) => {
    switch(color) {
      case 'blue': return 'ring-blue-400';
      case 'indigo': return 'ring-indigo-400';
      case 'purple': return 'ring-purple-400';
      case 'teal': return 'ring-teal-400';
      default: return 'ring-blue-400';
    }
  };

  const getImageOverlayColor = (color) => {
    switch(color) {
      case 'blue': return 'bg-blue-600';
      case 'indigo': return 'bg-indigo-600';
      case 'purple': return 'bg-purple-600';
      case 'teal': return 'bg-teal-600';
      default: return 'bg-blue-600';
    }
  };

  const getFeatureIconColor = (color) => {
    switch(color) {
      case 'blue': return 'text-blue-500';
      case 'indigo': return 'text-indigo-500';
      case 'purple': return 'text-purple-500';
      case 'teal': return 'text-teal-500';
      default: return 'text-blue-500';
    }
  };

  const getDividerColor = (color) => {
    switch(color) {
      case 'blue': return 'bg-blue-200';
      case 'indigo': return 'bg-indigo-200';
      case 'purple': return 'bg-purple-200';
      case 'teal': return 'bg-teal-200';
      default: return 'bg-blue-200';
    }
  };

  return (
    <div className="py-16 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-700 mb-3">
            AppSheet 기반 비즈니스 솔루션
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-indigo-600 mx-auto mb-6 rounded-full"></div>
          <p className="max-w-2xl mx-auto text-lg sm:text-xl text-gray-600">
            Google AppSheet로 구현된 맞춤형 업무 시스템으로 업무 효율을 높이세요.
          </p>
        </div>

        {/* 탭 네비게이션 */}
        <div className="flex flex-wrap justify-center mb-10 gap-2 px-2">
          {products.map((product, idx) => (
            <button
              key={idx}
              onClick={() => setActiveTab(idx)}
              className={`px-4 py-2 rounded-full text-sm sm:text-base font-medium transition-all duration-300 ${
                activeTab === idx 
                  ? `${getActiveTabColor(product.color)} text-white shadow-lg`
                  : 'bg-white text-gray-700 hover:bg-gray-100 shadow'
              }`}
            >
              {product.title}
            </button>
          ))}
        </div>

        <div className="mt-10 grid gap-8 grid-cols-1 md:grid-cols-2">
          {products.map((product, index) => (       
            <div
              key={index}
              className={`bg-white rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-500 overflow-hidden transform hover:-translate-y-1 ${
                activeTab === index ? `ring-2 ring-offset-4 ${getCardRingColor(product.color)}` : ''
              }`}
            >
              <div className={getCardHeaderGradient(product.color) + " py-3 px-6"}>
                <h3 className="text-2xl font-bold text-white">
                  {product.title}                
                </h3>
              </div>
              
              <div className="grid grid-cols-3 gap-3 p-4 bg-gray-50">
                {product.images.map((image, imgIndex) => (
                  <div 
                    key={imgIndex}
                    className="relative aspect-square cursor-pointer group bg-white rounded-xl overflow-hidden shadow-md"
                    onClick={() => handleImageClick(image, product, imgIndex)}
                  >
                    <img
                      src={image}
                      alt={`${product.title} ${imgIndex + 1}`}
                      className="w-full h-full object-contain p-2 transition-transform duration-500 group-hover:scale-110"
                    />
                    <div className={`absolute inset-0 ${getImageOverlayColor(product.color)} opacity-0 group-hover:opacity-20 transition-opacity duration-300`} />
                    <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300">
                      <span className="bg-white bg-opacity-90 text-gray-800 px-3 py-1 rounded-full text-sm font-medium shadow-lg">
                        확대보기
                      </span>
                    </div>
                  </div>
                ))}
              </div>
              
              <div className="p-6">
                <p className="text-base sm:text-lg text-gray-700 mb-5 italic">
                  {product.description}
                </p>
                <div className={`w-full h-0.5 ${getDividerColor(product.color)} mb-5 rounded-full`}></div>
                <ul className="space-y-3">
                  {product.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start text-base">
                      <svg
                        className={`h-6 w-6 ${getFeatureIconColor(product.color)} mr-3 flex-shrink-0`}
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      <span className="text-gray-700">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        {/* 이미지 모달 */}
        {selectedImage && (
          <div 
            className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-50 p-4 backdrop-blur-sm"
            onClick={() => {
              setSelectedImage(null);
              setCurrentImageIndex(0);
              setCurrentProduct(null);
            }}
          >
            <div className="relative max-w-4xl w-full max-h-[90vh] bg-white rounded-2xl overflow-hidden shadow-2xl">
              <button
                className="absolute top-4 right-4 text-gray-600 hover:text-gray-900 z-10 bg-white rounded-full p-2 shadow-md transition-all duration-200 hover:scale-110"
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedImage(null);
                  setCurrentImageIndex(0);
                  setCurrentProduct(null);
                }}
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>

              {/* 이미지 제목 */}
              <div className="absolute top-0 left-0 right-0 bg-gradient-to-b from-black to-transparent p-4 text-white z-10">
                <h3 className="text-xl font-semibold">{currentProduct?.title}</h3>
              </div>

              {/* 이전 버튼 */}
              {currentImageIndex > 0 && (
                <button
                  className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white rounded-full p-3 shadow-lg hover:bg-gray-100 transition-all duration-200 hover:scale-110 z-10"
                  onClick={handlePrevImage}
                >
                  <svg className="w-6 h-6 text-gray-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
                  </svg>
                </button>
              )}

              {/* 이미지 */}
              <div className="w-full h-full flex items-center justify-center bg-gray-100">
                <img
                  src={selectedImage}
                  alt="확대된 이미지"
                  className="max-w-full max-h-[80vh] object-contain p-4"
                  onClick={(e) => e.stopPropagation()}
                />
              </div>

              {/* 다음 버튼 */}
              {currentProduct && currentImageIndex < currentProduct.images.length - 1 && (
                <button
                  className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white rounded-full p-3 shadow-lg hover:bg-gray-100 transition-all duration-200 hover:scale-110 z-10"
                  onClick={handleNextImage}
                >
                  <svg className="w-6 h-6 text-gray-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                  </svg>
                </button>
              )}

              {/* 이미지 카운터 & 썸네일 */}
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black to-transparent p-4 flex items-center justify-center z-10">
                <div className="flex space-x-2">
                  {currentProduct?.images.map((img, idx) => (
                    <button
                      key={idx}
                      onClick={(e) => {
                        e.stopPropagation();
                        setSelectedImage(img);
                        setCurrentImageIndex(idx);
                      }}
                      className={`w-3 h-3 rounded-full transition-all duration-300 ${
                        currentImageIndex === idx ? 'bg-white scale-125' : 'bg-gray-400 hover:bg-gray-200'
                      }`}
                      aria-label={`이미지 ${idx + 1}`}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default WorkAppsheet;